import { BaseService } from '@services/BaseService'

const resource = 'hr/symptom'

class SymptomService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const symptomService = new SymptomService()
